<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="增加终端" name="first">
        <div class="addDef_form">
          <el-form ref="form" :model="form" label-width="100px" class="demo-ruleForm">
            <el-form-item label="*终端名称">
              <el-input v-model="form.fixTerm_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*终端类型">
              <el-select v-model="form.fixTerm_type" placeholder="请选择终端类型" >
                <div v-for="(termType,index) in listTermType" :key="index" @click="changeManu(termType.manu)">
                  <el-option :label="termType.type" :value="termType.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*终端串号">
              <el-input v-model="form.fixTerm_eui" placeholder="16个十六进制数"></el-input>
            </el-form-item>
            <el-form-item label="*终端厂商">
              <el-input v-model="form.manu" placeholder="根据选择的终端类型生成"></el-input>
            </el-form-item>
            <el-form-item label="*产品">
              <el-select v-model="form.product" placeholder="请选择相应厂商的产品" >
                <div v-for="(termType,index) in listTermProduct" :key="index">
                  <el-option :label="termType" :value="termType"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit2">确定增加</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      form: {
        fixTerm_type: '',
        fixTerm_eui: '',
        manu: '',
        product: '',
        fixTerm_name: ''
      },
      listTermType: {},
      listTermProduct: {}
    }
  },
  methods: {
    onSubmit2 () {
      let formdata = new FormData()
      formdata.append('user', window.sessionStorage.getItem('username'))
      formdata.append('type', this.form.fixTerm_type)
      formdata.append('deveui', this.form.fixTerm_eui)
      formdata.append('manu', this.form.manu)
      formdata.append('product', this.form.product)
      formdata.append('name', this.form.fixTerm_name)
      this.axios.post(this.$store.state.ip + 'termdef/addTerm', formdata,
        {
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        this.$message.success('固定式终端添加成功')
        this.form = {}
      }).catch(err => {
        console.log(err)
        this.$message.success('固定式终端添加失败')
      })
    },
    cancel () {
      this.form = {}
    },
    changeManu () {
      for (let i = 0; i < this.listTermType.length; i++) {
        if (this.listTermType[i].id === this.form.fixTerm_type) {
          this.form.manu = this.listTermType[i].manu
          this.listTermProduct = this.listTermType[i].products
          break
        }
      }
    }
  },
  created () {
    // 查询终端厂商及产品
    this.axios.get(this.$store.state.ip + 'termdef/listTermManus',
      {
        headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
      }).then(res => {
      this.listTermType = res.data.data
      // console.log(res.data.data)
    }).catch(err => {
      console.log(err)
    })
  },
  watch: {
    'form.fixTerm_type': function () {
      if (this.form.fixTerm_type !== '0') {
        this.changeManu()
      }
    }
  }
}
</script>

<style scoped>
  .addDef_form {
    width: 450px;
    margin-left: 20px;
    margin-top: 30px;
  }
  .el-input, .el-select {
    margin-left: 10px;
  }
  .el-select {
    width: 350px;
  }
</style>



// WEBPACK FOOTER //
// src/components/setting/addTerm.vue